<template>
  <div v-if="_customer">
    <div class="flex items-start">
      <div class="text-title whitespace-nowrap">Accounting Key:</div>
      <div class="flex flex-col">
        <div class="flex items-center">
          <span data-cy="accountingKeyText" class="ml-1">{{
            _customer.accounting_key || "Not Available"
          }}</span>
          <i
            v-if="_customer.links?.set_accounting_key"
            class="far fa-pen-to-square ml-1 link"
            data-cy="accountingKeyEditIcon"
            @click="toggleOpen"
          ></i>
        </div>
        <QBSyncBadge
          :synced="_customer.qbo_sync_status === 'succeeded' || true"
          :url="_customer.qbo_url"
          class="relative left-[5px]"
        />
      </div>
    </div>
    <AccountingKeyModal
      v-if="open"
      data-cy="accountingKeyModal"
      :customer="_customer"
      @save-success="emit('save-success')"
      @hide-modal="toggleOpen"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import QBSyncBadge from "@/Quickbooks/QBSyncBadge.vue";
import { Customer } from "@/typings/customer";
import AccountingKeyModal from "./AccountingKeyModal.vue";

const emit = defineEmits(["save-success"]);
const props = withDefaults(
  defineProps<{
    customer: Customer | null;
  }>(),
  { customer: null }
);
// Map props to computed to make it reactive
const _customer = computed(() => props.customer);
// This line is only to appease the compiler
// props are automatically exposed to the template
defineExpose({ customer: props.customer, emit });

const open = ref(false);

function toggleOpen() {
  open.value = !open.value;
}
</script>
